/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Subtenant } from '@/client';
import { ContentContainer } from '@/components/ContentContainer';
import { DeleteSubtenantModal } from '@/pages/Subtenants/DeleteSubtenantModal';
import { SubtenantsHierarchy } from '@/pages/Subtenants/SubtenantHierarchy/SubtenantsHierarchy';
import { SubtenantsHeader } from '@/pages/Subtenants/SubtenantsHeader';
import { Container } from '@/primitives/Container';

export function SubtenantsPage() {
  const navigate = useNavigate();
  const [deleteSubtenant, setDeleteSubtenant] = useState<Subtenant>();
  const [deleteIsPending, setDeleteIsPending] = useState(false);

  const editSubtenant = (subtenant: Subtenant) => {
    navigate(subtenant.id);
  };

  const closeDeleteDialog = () => {
    setDeleteSubtenant(undefined);
    setDeleteIsPending(false);
  };

  return (
    <ContentContainer width="100%">
      <Container>
        <SubtenantsHeader />
        <SubtenantsHierarchy editSubtenant={editSubtenant} setDeleteSubtenant={setDeleteSubtenant} />
        <DeleteSubtenantModal
          deleteSubtenant={deleteSubtenant}
          deleteIsPending={deleteIsPending}
          setDeleteIsPending={setDeleteIsPending}
          onCancelSubtenantDelete={closeDeleteDialog}
        />
      </Container>
    </ContentContainer>
  );
}
